import React from 'react';

import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

import StyleDemo from './components/demos/StyleDemo';
import StyledComponentsDemo from './components/demos/StyledComponentsDemo';
import Starter from './components/starter/starter';

import Viewport from './components/Viewport';

/** @jsxImportSource @emotion/react */

import { jsx, css } from '@emotion/react'

const styleDemoContainer = css`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const app = css`
  display: flex;
  flex-direction: row;
  @media (max-width: 768px) {
    flex-direction: column;
    min-height: 100vh;
  }
  .menu {
    display: flex;
    flex: 0 1 auto;
    min-height: 100vh;
    background-color: #1f2329;
    div {
      // padding: 20px;
      display: flex;
      flex-direction: column;
      @media (max-width: 768px) {
        flex-direction: row;
        flex: 1 0 auto;
        justify-content: space-around;
      }
    }
    a {
      text-decoration: none;
      color: #61dafb;
      margin-bottom: 5px;
      :hover {
        color: #51bbd7;
      }
    }
    @media (max-width: 768px) {
      min-height: 0;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
  }
`

function App() {
  return (
    <Router>
      <div css={app}>
        <div className='menu'>
          <div>
            {/* <Link to="/">3D Demo</Link> */}
            {/* <Link to="/style">Styles</Link> */}
            {/* <Link to="/starter">Starter</Link> */}
          </div>
        </div>
        <div className='content'>
          <Switch>

            <Route path="/style">
              <div css={styleDemoContainer}>
                <div>
                  <StyleDemo />
                  <StyledComponentsDemo />
                </div>
              </div>
            </Route>

            <Route path="/starter">
              <Starter />
            </Route>

            <Route path="/">
              <Viewport />
            </Route>

          </Switch>
        </div>
      </div>
    </Router>
  );
}

export default App;
